import { ComponentRenderer } from 'app/src/features/Landing/components/ComponentRenderer'
import { pageconfigurationsApi } from 'app/src/services/welfareportal'
import { useComponentRenderer, useWebAppContext } from 'app/src/shared/hooks'
import { useEffect, type ReactElement } from 'react'

export function Landing(): ReactElement {
  const context = useWebAppContext()
  const { getPage } = useComponentRenderer()
  const homePageConfig = pageconfigurationsApi.usePageRequestGet({
    pathParams: { id: 'homepage', templateBasePath: context.userInfo.welfareCampaign.configuration.frontend.templateId },
  })

  useEffect(() => {
    context.update({ breadCrumbItems: [] })
    //Evita loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ComponentRenderer(getPage(homePageConfig?.data))
}
